if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        console.log(mediaToSwitch);
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        mediaToSwitch.addEventListener('click', this.imageClicked.bind(this)); 
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    imageClicked(e) {
     
     let variantSelect = this.parentNode.parentNode.querySelector("variant-selects > select"); 
     let variantRadios = this.parentNode.parentNode.querySelector("variant-radios"); 
     let variantSwatches = this.parentNode.parentNode.querySelector("variant-swatches"); 
     const activeMediaId = e.currentTarget.dataset.target.split("__main-")[1]; 
     const mediaAlt = e.currentTarget.querySelector("img").alt 
     const mediaAltFilter = mediaAlt.split("-")[0] 
     if(variantSwatches){
      variantSwatches.querySelectorAll("input").forEach((option) => {
        if (mediaAlt == option.value) { 
          let IdColorSelected = option.getAttribute('data-id');
          let DataVariantTemplate = variantSwatches.getAttribute('data-template')
          const productForms = document.querySelectorAll(`#product-form-${DataVariantTemplate}, #product-form-installment-${DataVariantTemplate}`);

          productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = IdColorSelected;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
          
          let labelSwatch = variantSwatches.parentNode.parentNode.querySelector('label > b');
          labelSwatch.textContent = mediaAlt;
          variantSwatches.parentNode.querySelector("select").querySelectorAll("option").forEach((option2,index) => {
            
               if((option2).hasAttribute('selected')){
                 option2.removeAttribute('selected');
               }
             if (mediaAlt == option2.value) { 
               variantSwatches.parentNode.querySelector("select").options[index].defaultSelected = true;

               variantSwatches.parentNode.querySelector("select").value = option2;
               option2.checked = true;
             }
          });
          option.checked = true; 
          updateProduct(variantSwatches); 
        } 
       }); 
    }else{
      if (variantSelect) {
      variantSelect.querySelectorAll("option").forEach((option) => {
      if (mediaAlt == option.value) { 
        option.selected = true; 
        updateProduct(variantSelect); 
      } 
      }); 
     }
     else {
       variantRadios.querySelectorAll("input").forEach((option) => {
        if (mediaAlt == option.value) { 
          option.checked = true; 
          updateProduct(variantRadios); 
        } 
       }); 
     }
    }
     function updateProduct(selector) {
       selector.updateOptions(); 
       selector.updateMasterId(); 
       selector.updateURL(); 
       selector.updateVariantInput(); 
       selector.renderProductInfo(); 
     } 
   }  

    
    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      this.imageSlided(thumbnail);
   
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
      
      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }
    imageSlided(e) {
     let variantSelect = this.parentNode.parentNode.querySelector("variant-selects"); 
     let variantRadios = this.parentNode.parentNode.querySelector("variant-radios"); 
     let variantSwatches = this.parentNode.parentNode.querySelector("variant-swatches");
     const activeMediaId = e.dataset.target.split("__main-")[1];   
     const mediaAlt = e.querySelector("img").alt 
     const mediaAltFilter = mediaAlt.split("-")[0]
    if(variantSwatches){
       
  
      variantSwatches.querySelectorAll("input").forEach((option) => {
        if (mediaAlt == option.value) { 
            let IdColorSelected = option.getAttribute('data-id');
            let DataVariantTemplate = variantSwatches.getAttribute('data-template')
            const productForms = document.querySelectorAll(`#product-form-${DataVariantTemplate}, #product-form-installment-${DataVariantTemplate}`);
            productForms.forEach((productForm) => {
              const input = productForm.querySelector('input[name="id"]');
              input.value = IdColorSelected;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            });
            let labelSwatch = variantSwatches.parentNode.parentNode.querySelector('label > b');
            labelSwatch.textContent = mediaAlt;
            variantSwatches.parentNode.querySelector("select").querySelectorAll("option").forEach((option2) => {
              if (mediaAlt == option2.value) { 
               option2.checked = true;
              }
            });
          option.checked = true; 
          updateProduct(variantSwatches); 
        } 
       }); 
    }else{
      if (variantSelect) {
      variantSelect.querySelectorAll("option").forEach((option) => {
      if (mediaAlt == option.value) { 
        option.selected = true; 
        updateProduct(variantSelect); 
      } 
      }); 
     }
     else {
       variantRadios.querySelectorAll("input").forEach((option) => {
        if (mediaAlt == option.value) { 
          option.checked = true; 
          updateProduct(variantRadios); 
        } 
       }); 
     }
    }
      
     function updateProduct(selector) {
       selector.updateOptions(); 
       selector.updateMasterId(); 
       selector.updateURL(); 
       selector.updateVariantInput(); 
       selector.renderProductInfo(); 
     } 
   }
    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
